import appApi from '../../../../api/app-api';
import { toast } from 'react-toastify';
import { SalaryHistoryDbType } from '../../../../api/types/accountants/salary-history/salary-history.type';

export const getSalaryHistoryOperations = async (
  startDate: Date,
  endDate: Date,
  branchId: number,
  offset: number,
  limit: number,
  setSalariesData: (items: SalaryHistoryDbType[]) => void,
  setTotal?: (total: number) => void,
  setLoading?: (loading: boolean) => void,
) => {
  try {
    setLoading?.(true);
    const res = await appApi.getSalaryHistory(
      startDate,
      endDate,
      branchId,
      offset,
      limit,
    );
    const page = res.data.body;
    setSalariesData(page.data);
    setTotal?.(page.total);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  } finally {
    setLoading?.(false);
  }
};
